import styled from "styled-components";

import { Heading } from "@manamerge/mana-atomic-ui";

export const StyledHeading = styled(Heading)`
    margin-top: 100px;
`;
